import dayjs from 'dayjs';

// Memoized helper functions to prevent recreation on every render
export const formatCurrency = (value, currency = 'USD') => {
	return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value || 0);
};

export const formatPercentage = (value) => {
	return `${(value || 0).toFixed(2)}%`;
};

export const getChangeType = (percentageChange) => {
	if (percentageChange === null || percentageChange === undefined || percentageChange === 0) return null;
	return percentageChange > 0 ? 'increase' : 'decrease';
};

// Optimized transform functions with better null/undefined handling
export const transformDataForChart = (dataPoints = [], valueKey = 'value') => {
	if (!Array.isArray(dataPoints) || dataPoints.length === 0) return [];
	return dataPoints.map(dp => ({
		date: dayjs(dp.date).format('MMM DD'),
		[valueKey]: dp.value || 0
	}));
};

export const transformMultiSeriesDataForChart = (series, dateKey = 'date') => {
	if (!series || typeof series !== 'object' || Object.keys(series).length === 0) return [];
	
	const allDates = new Set();
	Object.values(series).forEach(s => {
		if (s && Array.isArray(s.data_points)) {
			s.data_points.forEach(dp => allDates.add(dp[dateKey]));
		}
	});
	
	if (allDates.size === 0) return [];
	
	const sortedDates = Array.from(allDates).sort((a, b) => dayjs(a).valueOf() - dayjs(b).valueOf());
	return sortedDates.map(date => {
		const entry = { date: dayjs(date).format('MMM DD') };
		for (const key in series) {
			if (series[key] && Array.isArray(series[key].data_points)) {
				const dataPoint = series[key].data_points.find(dp => dp[dateKey] === date);
				entry[key.toLowerCase().replace(/\s+/g, '')] = dataPoint ? (dataPoint.value || 0) : 0;
			}
		}
		return entry;
	});
}; 